import React from 'react';
import { useEffect } from 'react';
import AOS from 'aos';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import 'aos/dist/aos.css';
import '../Pages/Style.css';

const About = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,  // animation time in ms
            once: true,      // animate only once when scrolling down
            easing: 'ease-in-out',
            offset: 120,
        });
    }, []);
    const [ref, inView] = useInView({ triggerOnce: true });
    return (
        <div id='content' >
            <div
                className="home-background d-flex align-items-start"
                id="about-background"
                style={{
                    backgroundImage: `url('/Photos/startup-business-people-discussing-cafe.jpg')`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'top left',
                    height: '450px',
                    color: 'white' // optional: white text for better contrast
                }}
            > 
            <div className="w-100 text-end p-4 pt-5 me-4">
                    <h1 className="text-whitee">About Us</h1>
                </div>

                <div className="home-text">

                </div>
            </div>
            <div className="container py-5" data-aos="fade-up">
                <h3 className="text-primary mb-4" id='about-us'>About Us</h3>

                <div className="row align-items-center">
                    {/* Image Section */}
                    <div className="col-md-5 mb-4 mb-md-0">
                        <img
                            src="https://static.vecteezy.com/system/resources/previews/053/490/695/non_2x/job-interview-illustration-concept-modern-flat-illustration-of-a-woman-talking-to-a-man-with-a-laptop-isolated-in-the-background-vector.jpg"
                            alt="Team working"
                            className="img-fluid rounded shadow"
                        />
                    </div>

                    {/* Text Section */}
                    <div className="col-md-7">
                        <h2 className="mb-3" style={{ color: 'var(--color-orange)' }}>
                            We Build Lasting Relationships Between Candidates & Businesses
                        </h2>
                        <p>
                            At Delight Consultancy, we believe in building lasting relationships between candidates and businesses by fostering a strong, transparent, and collaborative approach. Our focus is not just on filling positions, but on creating meaningful connections that align with the values, goals, and culture of both parties. By understanding the unique needs of our clients and the aspirations of our candidates, we ensure that every placement is a long-term success, driving mutual growth and satisfaction. Through personalized service and a commitment to excellence, we continue to cultivate relationships that stand the test of time.
                        </p>




                    </div>
                </div>
            </div>
            <div className='container-fluid' id="counter-part">
                <div className='container' data-aos="fade-up">
                    <h2 className='counter-head'>We’ve worked with some great companies already.We think you should join them in your quest for top talent.</h2>
                    <div className='container'>
                        <p id='who'></p>
                    </div>

                    <div className="container py-5  text-center" ref={ref}>
                        <div className="row">
                            {/* Candidates */}
                            <div className="col-md-4 mb-4">
                                <h2 className="text display-5 fw-bold">
                                    {inView && <CountUp end={1250} duration={2} separator="," />}+
                                </h2>
                                <p className="fs-5">Candidates Registered</p>
                            </div>

                            {/* Jobs */}
                            <div className="col-md-4 mb-4">
                                <h2 className="text display-5 fw-bold">
                                    {inView && <CountUp end={320} duration={2} />}
                                </h2>
                                <p className="fs-5">Job Listings</p>
                            </div>

                            {/* Placed */}
                            <div className="col-md-4 mb-4">
                                <h2 className="text display-5 fw-bold">
                                    {inView && <CountUp end={890} duration={2} />}
                                </h2>
                                <p className="fs-5">Candidates Placed</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='container-fluid' id="wedo-page" data-aos="fade-up">
                <div className="container my-5">

                    <div className="row align-items-center">
                        {/* Left side content */}
                        <div className="col-md-6">
                            <img
                                src="https://unblast.com/wp-content/uploads/2020/05/Job-Interview-Illustration.jpg"
                                alt="Office"
                                className="img-fluid rounded"
                                style={{ maxHeight: '400px', width: '100%', objectFit: 'cover' }}
                            />
                        </div>
                        <div className="col-md-6">
                            <h3 className='business-head'>What We Do</h3>
                            <ul>
                                <li className='text-black'>Profound Knowledge of demographic and psychographic profiles for the IT & ITES Industry</li>
                                <li className='text-black'>In depth Knowledge of Micro hiring markets across the length and breadth of Bangalore city</li>
                                <li className='text-black'>Compensation benchmarking across all skill levels</li>
                                <li className='text-black'>Excellent understanding of online and offline tools of the assessments : English language spoken and Written, Analytical skills, Technical skills, and Numerical skills</li>
                                <li className='text-black'>Excellent relationship to facilitate key campus connect in South India</li>
                                <li className='text-black'>Compliance requirement across the organizations at all stages
                                </li>


                            </ul>
                        </div>



                    </div>
                </div>
            </div>
            <div className="container my-5" data-aos="fade-up" id='our-workk'>
                <div className="row" id='our-workk'>
                    <div className="text-center mb-4">
                        <h2 className="about-heading"> our work </h2>
                        <h3 className="text">Get to know who we are and what drives us forward.</h3>
                    </div>

                    {/* Vision */}
                    <div className="col-md-4 mb-4">
                        <div className="card h-100 shadow-sm">
                            <img
                                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQQ4C4PDadp8TmKZ-NySJwgZLkXl6ntzvP485gI5FIzEZF1829idTMaS6dy-OJD08IIoCE&usqp=CAU"
                                className="card-img-top"
                                alt="Vision"
                                height={300}
                            />
                            <div className="card-body">
                                <h5 className="card-title fw-bold">Our Vision</h5>
                                <p className="card-text">
                                    At Delight Consultancy, we envision a future where talent meets opportunity seamlessly. Our goal is to bridge the gap between great companies and great people.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Values */}
                    <div className="col-md-4 mb-4">
                        <div className="card h-100 shadow-sm">
                            <img
                                src="https://media.licdn.com/dms/image/v2/D5612AQGpIRBEfcu4xg/article-cover_image-shrink_600_2000/article-cover_image-shrink_600_2000/0/1696007466436?e=2147483647&v=beta&t=60LdytJjb0AGnxnCFoc7alBtuan8eueLxmZCixa_s0g"
                                className="card-img-top"
                                alt="Values"
                                height={300}
                            />
                            <div className="card-body">
                                <h5 className="card-title fw-bold">Our Values</h5>
                                <p className="card-text">
                                    Integrity, transparency, and excellence guide every step of our process. We work with purpose, passion, and a commitment to creating meaningful career paths.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Team */}
                    <div className="col-md-4 mb-4">
                        <div className="card h-100 shadow-sm">
                            <img
                                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQI29BHGYZUWYXZAHrCqqR1QGeubVildLVdEBDl_zNx9zTIh6lf4XpBDbbSgj-ui8J70c0&usqp=CAU"
                                className="card-img-top"
                                alt="Team"
                                height={300}
                            />
                            <div className="card-body">
                                <h5 className="card-title fw-bold">Meet the Team</h5>
                                <p className="card-text">
                                    Our diverse team of experts brings together experience, innovation, and empathy. We’re here to support job seekers and employers every step of the way.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div >
    );
};
export default About;
